module.exports = __webpack_public_path__ + "img/voice.8c18474.png";